import { ChangeEvent, FC, useEffect, useState } from 'react';
import styles from './FormInput.module.scss';

export interface RadioOption {
  id: string;
  label: string;
}

export interface RadioProps {
  label?: string;
  name: string;
  options: RadioOption[];
  required?: boolean;
  onChange?: (opt: RadioOption, evt: ChangeEvent<HTMLInputElement>) => void;
  value?: string;
}

const Radio: FC<RadioProps> = ({ label, name, onChange, options, required, value, ...props }) => {
  const [realLabel, setRealLabel] = useState(label || /* istanbul ignore next */ '');
  useEffect(() => {
    /* istanbul ignore next */
    setRealLabel(required ? `${label}*` : label || '');
  }, [label, required]);

  return (
    <div {...props} className={styles.wrapper}>
      <div className={styles.label}>{realLabel}</div>
      <div>
        {options.map((option) => (
          <label htmlFor={`${name}-${option.id}`} className={styles.radioOption} key={option.id} data-test="option">
            <input
              type="radio"
              name={name}
              id={`${name}-${option.id}`}
              onChange={(e) => {
                /* istanbul ignore else */
                if (onChange) onChange(option, e);
              }}
              checked={value ? value === option.id : /* istanbul ignore next */ undefined}
            />
            <span className={styles.optionLabel}>{option.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default Radio;
